import { registerPageStore } from "src/pages/RegisterPage/RegisterPageStore";
import { ifDef } from "./ifDef";

export const gateway = (path: string) => `/gateway-service${path}`;

export const gatewayServices = (path: string) => gateway(`/services${path}`);
export const apiMsObjectUrl = (path: string) =>
  gatewayServices(`/ms-object/api${path}`);

// Для случая, когда выполняется регистрация пользователя в неавторизованном режиме,
// происходит проксирование запросов в другой сервис.
const withRegistration = (prefix: string, path: string) =>
  ifDef(registerPageStore?.settingsId, (id) =>
    apiExtRegUrl(`/registration/${id}${path}`),
  ) ?? `${prefix}${path}`;

export const apiFilesUrl = (path: string) =>
  gatewayServices(`/file-service/api/files${path}`);

export const apiAdminUrl = (path: string) =>
  gatewayServices(`/ms-object/api${path}`);

export const apiAdminUrlV2 = (path: string) =>
  gatewayServices(`/ms-object/admin/api${path}`);

export const apiObjUrl = (path: string) =>
  withRegistration(gatewayServices("/ms-object/api"), path);

export const apiTranslationsUrl = (path: string) =>
  apiMsObjectUrl(`/translations${path}`);

export const apiAuditUrl = (path: string) => apiObjUrl(`/audit${path}`);

export const apiAuditServiceUrl = (path: "/audit") =>
  gatewayServices(`/audit-service/api${path}`);

// Новый
export const apiAuthUrl = (path: string) => ` /auth-service/api${path}`;
// Старый
// export const apiAuthUrl = (path: string) => `/api/auth${path}`;

// только для rest. не для ws
export const apiPushUrl = (path: string) =>
  `/gateway-service/services/push-service/api${path}`;

export const apiExtRegUrl = (path: string) =>
  gatewayServices(`/external-registration-service/api${path}`);

export const apiChatUrl = (path: string) =>
  gatewayServices(`/chat-service/api${path}`);

export const apiBomUrl = (path: string) =>
  gatewayServices(`/bom-service${path}`);

export const apiMeasurementChart = (path: string) =>
  gatewayServices(`/measurement-chart-service/api${path}`);

export const apiTechpack = (path: string) =>
  gatewayServices(`/techpack-service/api${path}`);

export const apiPlanning = (path: string) =>
  gatewayServices(`/planning-service/api/planning${path}`);

export const apiAsrtTable = (path: string) =>
  gatewayServices(`/assortment-table-service/api${path}`);

export const apiConfigUrl = (path: string) => apiAdminUrl(`/config${path}`);
